import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE_KEYS } from 'src/app/shared/types/types';
import { SharedService } from 'src/app/shared/services/other/shared.service';
import { TranslatorService } from 'src/app/shared/services/other/translator.service';
import { LOGIN_CONTENT } from 'src/app/shared/texts/texts';
import { SamhitaOndcWoCService } from 'src/app/shared/services/api/samhita-ondc-wo-c.service';
import { ToastService } from 'src/app/shared/services/other/toaster.service';
import { AuthService } from 'src/app/shared/services/api/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginType: 'otp' | 'username-password' = 'otp';

  loginContent = LOGIN_CONTENT

  get activeLan(){
    return this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.CURRENT_LANGUAGE)
  }

  get targetLan(){
    return this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TARGET_LANGUAGE)
  }

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private translateService : TranslatorService,
    private samhitaWoService : SamhitaOndcWoCService,
    private toaster:ToastService,
    private authService : AuthService
  ) { }

  ngOnInit(): void {
    this.translateService.lanUpdates.subscribe((res)=>{
      if(res){
        this.loginContent = LOGIN_CONTENT
        if(res !== 'en') this.translateStaticContents()
      }
    })
    if(this.targetLan && this.activeLan) this.translateStaticContents()
  }

  getInSideApp(tokens: { access: string }, userId: string, loginType: string) {
    this.router.navigate([`auth/${tokens.access}`], { queryParams: { userId, loginType } });
  }

  clearSession() {
    this.sharedService.removeDataToSessionStorage(SESSION_STORAGE_KEYS.SESSION_TOKEN);
    this.sharedService.removeDataToSessionStorage(SESSION_STORAGE_KEYS.USER_INFO);
  }

  onloginTypeChange(event: any): void {
    this.loginType = event.detail.value;
  }

  movetoSignup() {
    this.router.navigate(['/signup']);
  }
  moveToHome(){
    this.router.navigate(['home'])
  }

  async translateStaticContents(){
    const updatedStaticContent = await this.translateService.translateSection(this.loginContent) as string[];

    if(updatedStaticContent) this.loginContent = updatedStaticContent
  
  }

  loginWithSamhita(){
    this.authService.loginWithSamhita()
  }


  

}
